<template>
    <div>
        <top-bar :showBack="true"
                :title="lbl.editprofile.title"
                @onClickBack="Clickback()"></top-bar>
        <div class="edit-profile-content" v-if="isLoadProfile">

            <!-- input gender -->
            <div class="row no-gutters">
                 <div class="col-2"></div>
                 <div class="col-10 gender">
                     <div class="col-4 gender-item" @click="ClickRadio('MS')">
                         <img v-if="prefix == 'MS'" src="@/assets/icon/radio-active@2x.png" />
                         <img v-if="prefix != 'MS'" src="@/assets/icon/radio-inactive@2x.png" />
                         <div class="gender-name">{{lbl.editprofile.ms}}</div>
                     </div>
                     <div class="col-4 gender-item" @click="ClickRadio('MRS')">
                         <img v-if="prefix == 'MRS'" src="@/assets/icon/radio-active@2x.png" />
                         <img v-if="prefix != 'MRS'" src="@/assets/icon/radio-inactive@2x.png" />
                          <div class="gender-name">{{lbl.editprofile.mrs}}</div>
                     </div>
                     <div class="col-4 gender-item" @click="ClickRadio('MR')">
                         <img v-if="prefix == 'MR'" src="@/assets/icon/radio-active@2x.png" />
                         <img v-if="prefix != 'MR'" src="@/assets/icon/radio-inactive@2x.png" />
                          <div class="gender-name">{{lbl.editprofile.mr}}</div>
                     </div>
                 </div>
            </div>


            <!-- input first name -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                    <div class="icon-register-input">
                        <img src="@/assets/img/01-register/ic-name@3x.png">
                    </div>
                </div>
                <div class="col-10">
                    <input-text inputId="profile-name"
                                v-model="profileDior.firstName"
                                :inputLbl="lbl.register.firstname"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :errorInfo="errorInfo[0]"
                                :isTextOnly="true"
                                :blockAutoComplete="true"
                                :showLblOnlyHasInput="true"
                    ></input-text>
                </div>
            </div>

            <!-- input last name -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                    <div class="icon-register-input">
                    </div>
                </div>
                <div class="col-10">
                    <input-text inputId="profile-lastname"
                                v-model="profileDior.lastName"
                                :inputLbl="lbl.register.lastname"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :errorInfo="errorInfo[1]"
                                :isTextOnly="true"
                                :blockAutoComplete="true"
                                :showLblOnlyHasInput="true"
                    ></input-text>
                </div>
            </div>

            <!-- input birthdate -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                    <div class="icon-register-input">
                        <img src="@/assets/img/01-register/ic-birthday@3x.png">
                    </div>
                </div>
                <div class="col-10">
                    <dropdown-date :inputLbl="lbl.register.birthdate"
                                   :isFirstSave="isFirstSave"
                                   :errorInfo="errorInfo[2]"
                                   :inputDisabled="true"
                                   :isFullLbl="true"
                                   :setDay="profileDior.birthDay < 10 ? '0'+profileDior.birthDay : profileDior.birthDay"
                                   :setMonth="profileDior.birthMonth  < 10 ? '0'+profileDior.birthMonth : profileDior.birthMonth"
                                   :setYear="profileDior.birthYear"
                    ></dropdown-date>
                </div>
            </div>

            <!-- input contact number -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                    <div class="icon-register-input">
                        <img src="@/assets/img/03-profile/ic-phone@3x.png">
                    </div>
                </div>
                <div class="col-10">
                    <input-contact-number inputId="profile-contactnumber"
                                v-model="profileDior.mobileNumber"
                                :inputLbl="lbl.editprofile.contactnumber"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :errorInfo="errorInfo[9]"
                                :blockAutoComplete="true"
                                :showLabelOnInputOnly="true"
                                :inputDisabled="true"
                                delimeter="-"
                    ></input-contact-number>
                </div>
            </div>



            <!-- input email -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                    <div class="icon-register-input">
                        <img src="@/assets/img/01-register/ic-email@3x.png">
                    </div>
                </div>
                <div class="col-10">
                    <input-email inputId="profile-email"
                                v-model="profileDior.email"
                                :inputLbl="lbl.register.email"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :errorInfo="errorInfo[3]"
                                :blockAutoComplete="true"
                                :showLblOnlyHasInput="true"
                    ></input-email>
                </div>
            </div>

            <!-- input address text -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                    <div class="icon-register-input">
                        <img src="@/assets/img/01-register/ic-address@3x.png">
                    </div>
                </div>
                <div class="col-10">
                    <input-text-area inputId=""
                                     v-model="profileDior.address"
                                     :inputLbl="lbl.register.address"
                                     :isFirstSave="isFirstSave"
                                     :isShowErrorLbl="false"
                                     :errorInfo="errorInfo[4]"
                                     :showLblOnlyHasInput="true"
                    ></input-text-area>
                </div>
            </div>

            <!-- form address -->
            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                </div>
                <div class="col-10 wrap-form-address">
                    <form-address
                        formId="form-address-profile"
                        :address="addressModel"
                        :setAddress="addressModelDior"
                        :lblShipping="lbl.shipping"
                        :isFirstSave="isFirstSave"
                        :isShowErrorLbl="false"
                        :zipcodeError="errorInfo[5]"
                        :provinceError="errorInfo[6]"
                        :districtError="errorInfo[7]"
                        :subDistrictError="errorInfo[8]"
                        v-if="isLoadProfile"
                    ></form-address>
                </div>
            </div>

            <div class="row no-gutters">
                <div class="icon-input col-2 d-flex justify-content-end">
                </div>
                <div class="col-10">
                    <div class="wrap-btn-continue">
                        <button class="btn-black" @click="clickSave()">{{lbl.default.continue}}</button>
                    </div>
                </div>
            </div>


        </div>
        <modal view="register-main" :busModal="busModal"></modal>
    </div>
</template>

<script>
import Vue from "vue";
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
import { TrackingService } from "@/helper/TrackingHelper";

import TopBar from "@/components/TopBar.vue";
import InputText from "@/components/common/input/Text.vue";
import InputEmail from "@/components/common/input/Email.vue";
import DropdownDate from "@/components/common/input/DropdownDate.vue";
import InputTextArea from "@/components/common/input/TextArea.vue";
import FormAddress from "@/components/common/form/FormAddressDropDown.vue";
import InputContactNumber from "@/components/common/input/ContactNumber.vue";

import { DiorPorfileModel } from "@/model/Dior/DiorProfileModel.js"
import { AddressModel } from "@/model/AddressModel.js";
import DiorApi from "@/service/dior/DiorApi.js";
import Modal from "@/components/modal/Modal.vue";

export default {
    name: "Profile",
    components: {
        TopBar,
        InputText,
        InputEmail,
        DropdownDate,
        InputTextArea,
        FormAddress,
        InputContactNumber,
        Modal
    },
    data: function() {
        return {
            isLogin: false,
            isLoadProfile: false,
            profile: {},
            lbl: Locale.getLbl(),
            localeCode: Locale.getLocaleCode(),

            profileDior: new DiorPorfileModel(),
            isFirstSave: true,
            errorInfo: [],

            addressModel: null,
            addressModelDior: null,
            prefix: '',
            busModal: new Vue(),
            tracking: new TrackingService(this)
        };
    },
    created: function() {
        console.log("editprofile");
        Account.loginStatus().then((status) => {
            this.isLogin = status;
            this.profile = Account.getCacheProfile();
            this.showLoading();
            Account.apiGetProfileDior().then((res) => {
                this.profileDior.setDataFormApiMemberProfile(res.data);
                this.addressModel = new AddressModel();
                this.addressModel.strZipcode = this.profileDior.zipcode;
                this.addressModelDior = new AddressModel();
                this.addressModelDior.strZipcode = this.profileDior.zipcode;
                this.addressModelDior.strProvinceName = this.profileDior.province;
                this.addressModelDior.strDistrictName = this.profileDior.district;
                this.addressModelDior.strSubDistrictName = this.profileDior.subDistrict;
                this.prefix = this.profileDior.prefix;
                Util.log(this.profileDior);
                console.warn("-------------------------- Prefix ------------------");
                console.log(this.prefix);
                this.isLoadProfile = true;
                this.hideLoading();

            }).catch((err) => {
                this.hideLoading();
                if (err.response) {
                    console.log(err.response.data);
                } else {
                    console.log(err);
                    this.showErrorConnectModal();
                }

            });
        });

        var formInputCount = 10;
        for (var i=0 ; i<formInputCount ; i++) {
            this.errorInfo.push({ isValid: true, msg: '',});
        }

    },
    methods: {
        Clickback: function() {
            this.$router.push("/profile");
            this.tracking.event('Edit_Profile', 'click_back');
        },
        validateForm: function() {
            for (var i in this.errorInfo) {
                if (i >= 4 && i<= 9) {
                    break;
                }
                if (!this.errorInfo[i].isValid) {
                    return false;
                }
            }
            return true;
        },

        clickSave: function() {
            this.isFirstSave = false;
            if (this.validateForm()) {
                // console.log(this.addressModel);
                this.profileDior.zipcode = this.addressModel.strZipcode;
                this.profileDior.province = this.addressModel.strProvinceName;
                this.profileDior.district = this.addressModel.strDistrictName;
                this.profileDior.subDistrict = this.addressModel.strSubDistrictName;
                this.profileDior.prefix = this.prefix;
                var params = this.profileDior.getParams();

                if (params.address) {

                    params.address = params.address.replace(/\r?\n|\r/g, " ");
                }
                this.updateMember(params);
                // console.log(params);
                this.tracking.event('Edit_Profile', 'click_update');
            }
        },

        updateMember: function(params) {
            var token = Account.getToken();
            DiorApi.updateMember(token, params).then((res) => {
                console.log(res.data);
                this.$router.push("/profile");
                //this.showSuccess();
            }).catch((err) => {
                if (err.response) {
                    console.log(err.response.data);
                } else {
                    console.log(err);
                }
            });
        },
        ClickRadio: function(prefix) {
            this.prefix = prefix
        },
        showLoading: function() {
            this.busModal.$emit('showLoadingModal', {});
        },
        hideLoading: function() {
            this.busModal.$emit('hideLoadingModal', {});
        },
        showErrorConnectModal: function() {

            var configModal = {

                message: this.lbl.error_connect.message,
                strBtnOk: this.lbl.error_connect.btn_close,
            };
            this.busModal.$emit('showErrorConnectModal', configModal);
        },

    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/page/RegisterForm.scss";
    @import "@/style/page/editprofile.scss";
</style>
